const theArmstrongCompanyKey = 'couspPXStdbHpv7l3pSr8ZlvRL41ndmqZbd9';
export const disableJobCreationCompanyKeys = new Set([theArmstrongCompanyKey]);
